import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PlanoContasEmpresaRoutingModule } from './plano-contas-empresa-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PlanoContasEmpresaRoutingModule
  ]
})
export class PlanoContasEmpresaModule { }
